import api from "./baseApi";
import endpoints from "./endpoints";

export const getDashboard = async () => {
  try {
    const res = await api.get(endpoints.dashboard.base);

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to load dashboard data";

    throw new Error(message);
  }
};

export const searchGuest = async (keyword) => {
  try {
    const res = await api.get(
      endpoints.dashboard.searchGuest,
      {
        params: {
          q: keyword,
        },
      }
    );

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message ??
      "Failed to search guest.";

    throw new Error(message);
  }
};